<div class="modal-header">
  <h4 class="modal-title--delete" id="modal-basic-title">{{ translationFileSection + '.modal-delete-item-title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body-delete">
  <span class="fw-bold">{{ translationFileSection + '.modal-delete-item-sub-title' | translate }}</span>
  <span class="">{{ translationFileSection + '.modal-delete-item-content' | translate }}</span>
</div>
<div class="modal-footer modal-delete">
  <button type="button" class="cancel fw-bold" (click)="closeModal()">
    {{ translationFileSection + '.modal-delete-cancellation' | translate }}
  </button>
  <button type="button" class="btn confirm-delete d-flex" (click)="onDelete()">
    <mat-icon svgIcon="trash-icon"></mat-icon>
    <span class="fw-bold align-self-center">{{ translationFileSection + '.modal-delete-validation' | translate | uppercase }}</span>
  </button>
</div>
